// src/lib/useDpcTensu.ts
// DPC 点数タブ用 hook。 14 桁 DPC コード + dpcfy → 包括点数 (sheet 16)。
// 14 桁が空 or 14 桁未満なら fetch しない。 404 はマッチなし扱い (= 通常エラーではない)。
// Task 4: dpcfy (= マスタ改定年度 2024/2026) を引数追加。 未指定 fallback は R8。
import { useQuery } from "@tanstack/react-query";
import type { DpcTensuResponse } from "@shared/api";
import { GP_MODE_HEADER } from "./gpMode";

export function useDpcTensu(dpc14: string, dpcfy: number | null = null) {
  const valid = /^[0-9xX]{14}$/.test(dpc14);
  const fy = dpcfy === 2024 ? 2024 : 2026;  // null や他値は R8 fallback
  return useQuery({
    queryKey: ["dpc_tensu", dpc14, fy],
    queryFn: async (): Promise<DpcTensuResponse | { notFound: true }> => {
      const r = await fetch(`/api/query/dpc_tensu?dpc14=${encodeURIComponent(dpc14)}&dpcfy=${fy}`, {
        credentials: "include",
        headers: { ...GP_MODE_HEADER },
      });
      if (r.status === 404) return { notFound: true };
      if (!r.ok) throw new Error(`dpc_tensu ${r.status}`);
      return (await r.json()) as DpcTensuResponse;
    },
    enabled: valid,
    staleTime: 60 * 60_000,   // 1 時間 (= マスタ準静的)
  });
}
